import styled from '@emotion/styled';

export const EditModalContainer = styled.div`
  padding: 16px;
`;
